<template>
  <div id='page-wrapper'>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>الخطوط</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
            هنا يتم تغيير كلمة المرور
            </div>
            <div class='form-group col-lg-12 col-sm-12' style="padding: 10px">
              <div :class="isDanger ? 'alert-danger' : 'alert-success'" class="alert  alert-dismissable" v-if="message">
                    {{message}}
              </div>
                <form role="form">
                    <fieldset>
                      <div class="form-group">
                          <input class="form-control" placeholder="كلمة المرور القديمة" v-model="oldPassword" name="password" type="password" value="">
                      </div>
                      <div class="form-group">
                          <input class="form-control" placeholder="كلمة المرور الجديدة" v-model="newPassword" name="password" type="password" value="">
                      </div>
                      <div class="form-group">
                          <input class="form-control" placeholder="إعادة كلمة المرور الجديدة" v-model="reNewPassword" name="password" type="password" value="">
                      </div>
                        <!-- Change this to a button or input when using this as a form -->
                        <div class="form-group">
                            <button type="submit" class="btn btn-info btn-block" @click.prevent="performLogin" > تغيير </button>
                        </div>
                    </fieldset>
                </form>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Login',
  data () {
    return {
      isDanger: true,
      newPassword: '',
      reNewPassword: '',
      oldPassword: '',
      message: '',
      isLoading: false
    }
  },
  methods: {
    performLogin () {
      this.isLoading = true
      axios.post(this.$apiURL + 'auth/changePassword', {
        token: localStorage.getItem('token'),
        newPassword: this.newPassword,
        reNewPassword: this.reNewPassword,
        oldPassword: this.oldPassword
      })
        .then(res => {
          this.isLoading = false
          this.isDanger = false
          this.message = res.data.message
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.message = err.response.data.message
          this.isLoading = false
          this.isDanger = true
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue